<script setup lang="ts">
  import { MpText } from '@borg/ui';

  const props = defineProps<{
    articleId?: string;
  }>();

  const { data: featuredArticles } = await featuredArticlesRepository.getMany(props.articleId);
  const { data: popularTopics } = await popularTopicsRepository.getMany();
</script>

<template>
  <div class="taa">
    <div v-if="popularTopics && popularTopics.length > 0">
      <MpText as="h2">
        {{ $t(`mp_article.popular`) }}
      </MpText>
      <TagList :topics="popularTopics" />
    </div>
    <div v-if="featuredArticles && featuredArticles.length > 0">
      <MpText as="h2">
        {{ $t(`mp_article.featured`) }}
      </MpText>
      <ArticleList
        :articles="featuredArticles"
        :show-image="false"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
  .taa {
    display: flex;
    flex-direction: column;
    gap: var(--mp-space-90);
  }
</style>
